/*eslint-disable*/ import type { Messages } from '@lingui/core';
export const messages = JSON.parse(
  '{"native.advertisement":"reklam"}'
) as Messages;
